export function csrfToken(): string {
    if (typeof document === 'undefined') return '';
    const el = document.querySelector('meta[name="csrf-token"]');
    return (el && (el as HTMLMetaElement).content) || '';
}

export function xsrfToken(): string {
    if (typeof document === 'undefined') return '';

    const cookie = document.cookie
        .split('; ')
        .find((part) => part.startsWith('XSRF-TOKEN='));

    if (!cookie) return '';

    const value = cookie.slice('XSRF-TOKEN='.length);

    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}

export function csrfHeaders(): Record<string, string> {
    const xsrf = xsrfToken();

    if (xsrf) {
        return { 'X-XSRF-TOKEN': xsrf };
    }

    const token = csrfToken();

    return token ? { 'X-CSRF-TOKEN': token } : {};
}


